import React from 'react';
import { Button } from 'reactstrap';

const UpgradeAsTeamMember = ({ onClick, text }) => (
    <Button className={text ? `primary-btn-style primary-btn-xs` : 'primary-btn-style'} onClick={onClick}>
        <i className="material-icons align-text-bottom ">arrow_upward</i>
        {text && (
            <React.Fragment>
                {` `}
                {text}
            </React.Fragment>
        )}
    </Button>
);

export default UpgradeAsTeamMember;
